export class UpdateCatalogRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "connection",
            "baseName": "connection",
            "type": "FederatedConnection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateCatalogRequest.attributeTypeMap;
    }
    constructor() {
    }
}
